import revive_payload_client_4sVQNw7RlN from "/home/circleci/reflect-front/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/circleci/reflect-front/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/circleci/reflect-front/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/circleci/reflect-front/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/circleci/reflect-front/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/circleci/reflect-front/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/circleci/reflect-front/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/circleci/reflect-front/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/circleci/reflect-front/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/circleci/reflect-front/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tbFNToZNim from "/home/circleci/reflect-front/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import apiGqlClient_OLDeQ9YjtO from "/home/circleci/reflect-front/plugins/apiGqlClient.ts";
import chart_3lUUfbbx0f from "/home/circleci/reflect-front/plugins/chart.ts";
import i18n_VfGcjrvSkj from "/home/circleci/reflect-front/plugins/i18n.ts";
import june_vKl5Z9zBCb from "/home/circleci/reflect-front/plugins/june.ts";
import sentryClient_FH3ccB0tdD from "/home/circleci/reflect-front/plugins/sentryClient.ts";
import toast_ysMjUcU7eJ from "/home/circleci/reflect-front/plugins/toast.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tbFNToZNim,
  apiGqlClient_OLDeQ9YjtO,
  chart_3lUUfbbx0f,
  i18n_VfGcjrvSkj,
  june_vKl5Z9zBCb,
  sentryClient_FH3ccB0tdD,
  toast_ysMjUcU7eJ
]